
import { Facebook, Twitter, Instagram, Linkedin, Globe } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white py-12 border-t border-gray-100">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-16">
          <div className="md:w-1/3">
            <a href="/" className="flex items-center space-x-2 mb-6">
              <div className="w-8 h-8 rounded-full bg-black flex items-center justify-center text-white font-bold text-xs">
                <Globe className="w-4 h-4" />
              </div>
              <span className="font-bold text-xl">visanow.io</span>
            </a>
            <p className="text-gray-600 mb-6 max-w-md">
              Your all-in-one platform for international opportunities, language exam preparation, travel guides, and university admissions.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold mb-4">Legal</h3>
              <ul className="space-y-3 text-gray-600">
                <li>
                  <a href="/privacy-policy" className="hover:text-black transition-colors">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="hover:text-black transition-colors">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="#cookies" className="hover:text-black transition-colors">
                    Cookie Policy
                  </a>
                </li>
                <li>
                  <a href="#disclaimer" className="hover:text-black transition-colors">
                    Disclaimer
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Company</h3>
              <ul className="space-y-3 text-gray-600">
                {["About", "Contact", "Careers", "Culture", "Blog"].map((item, i) => (
                  <li key={i}>
                    <a href="#" className="hover:text-black transition-colors">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Support</h3>
              <ul className="space-y-3 text-gray-600">
                {["Help Center", "Getting Started", "Community", "Contact Us"].map((item, i) => (
                  <li key={i}>
                    <a href="#" className="hover:text-black transition-colors">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} visanow.io. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors">
              <Facebook size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors">
              <Twitter size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors">
              <Instagram size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
